

import { ArcClusterNode } from './ArcClusterNode';
import { EventNode } from './EventNode';
import { SectionNode } from './SectionNode';

import type { NodeTypes } from '@xyflow/react';

/**
 * Node type registry for the narrative graph
 */
export const nodeTypes = {
  section: SectionNode,
  arcCluster: ArcClusterNode,
  event: EventNode,
} as unknown as NodeTypes;

export { SectionNode, ArcClusterNode, EventNode };
